export function syntaxHighlight(json) {
    if (!json) return '';
    if (typeof json !== "string") {
        json = JSON.stringify(json, null, 2);
    }
    json = json.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|\b\d+\b)/g, function (match) {
        let cls = "json-number";
        if (/^"/.test(match)) {
            cls = /:$/.test(match) ? "json-key" : "json-string";
        } else if (/true|false/.test(match)) {
            cls = "json-boolean";
        } else if (/null/.test(match)) {
            cls = "json-null";
        }
        return `<span class="${cls}">${match}</span>`;
    });
}

export function parseContentMarkupToJSON(markup) {
    const pattern = /\[(.*?)\](?:\s*\{(.*?)\})?/g;
    const contentList = [];
    let match;
    while ((match = pattern.exec(markup)) !== null) {
        const text = match[1];
        const image = match[2] || null;
        const contentItem = { text, image };
        contentList.push(contentItem);
    }
    return contentList;
}

export function parseKeywordsMarkupToJSON(markup) {
    // Regular expression to capture text, definition, and optional synonyms
    const regex = /\[([^\]]+)]\{([^}]+)\}(?:\(([^)]+)\))?/g;
    const result = [];
    let match;

    while ((match = regex.exec(markup)) !== null) {
        // Destructure the matched groups into text, definition, and synonyms
        const [, text, definition, synonyms] = match;

        result.push({
            text: text.trim(),
            definition: String(definition).trim(),
            synonyms: synonyms || ""
        });
    }

    return result;
}

export function isValidMarkupContent(markup) {
    const pattern = /\[(.*?)\](?:\s*\{(.*?)\})?/g;
    let match;

    while ((match = pattern.exec(markup)) !== null) {
        const text = match[1];

        // Check that `text` content is present inside [ ].
        if (!text || text.trim() === '') {
            return false;
        }
    }

    // If no matches found and markup is not empty, it's invalid.
    return markup === '' || pattern.test(markup);
}

export function isValidKeywordsMarkupContent(markup) {
    const regex = /\[([^\]]+)]\{([^}]+)\}(?:\(([^)]+)\))?/g;
    let match;

    while ((match = regex.exec(markup)) !== null) {
        const text = match[1];

        // Check if text is non-empty as the definition, and synonyms are optional fields
        if (!text || text.trim() === '') {
            return false;
        }
    }

    return markup === '' || regex.test(markup);
}

export function parseContentToParagraph(markup) {
    const pattern = /\[(.*?)\](?:\s*\{.*?\})?/g;
    let paragraph = '';
    let match;

    while ((match = pattern.exec(markup)) !== null) {
        const text = match[1]; // Extract the text inside the brackets
        paragraph += text.trim() + ' '; // Append to the paragraph with a space
    }

    return paragraph.trim(); // Remove any trailing spaces
}

export function parseKeywords(markup) {
    const pattern = /\[(.*?)\]/g; // Match text inside [ ]
    let keywords = [];
    let match;

    while ((match = pattern.exec(markup)) !== null) {
        keywords.push(match[1]); // Add the matched text to the keywords array
    }

    return keywords.join(', '); // Return a comma-separated string
};

// export const abbreviations = /\b(?:Mr|Mrs|Ms|Dr|Prof|Sr|Jr|vs|etc|i\.e|e\.g|approx|Inc|Corp|Ltd|Co|St|Ave|Blvd|Rd|Dept|Univ|Jan|Feb|Mar|Apr|Jun|Jul|Aug|Sep|Sept|Oct|Nov|Dec|Mon|Tue|Wed|Thu|Fri|Sat|Sun|U\.S|U\.K|A\.I|M\.I\.T|N\.Y|Calif|D\.C)\./gi;

// Common abbreviations that shouldn't end sentences
export const abbreviations = /\b(?:Mr|Mrs|Ms|Dr|Prof|Rev|Fr|Hon|Capt|Col|Gen|Lt|Sgt|Adm|Inc|Ltd|Co|Corp|Univ|Dept|Gov|vs|etc|i\.e|e\.g|cf|et al|Ph\.D|M\.D|B\.A|M\.A|D\.D\.S|J\.D|a\.m|p\.m|ft|in|cm|kg|oz|U\.S\.A|B\.B\.C|St|Ave|Blvd|Rd|Jan|Feb|Mar|Apr|Jun|Jul|Aug|Sep|Sept|Oct|Nov|Dec|Mon|Tue|Wed|Thu|Fri|Sat|Sun|U\.S|U\.K|A\.I|M\.I\.T|N\.Y|Calif|D\.C|approx)\./gi;

